<div class="home-expertise">
  <app-gradient class="gradient gradient__left"></app-gradient>
  <app-gradient class="gradient gradient__right"></app-gradient>
  <div class="home-expertise__container">
    <h2 class="heading-m home-expertise__title">
      {{title}}
    </h2>
    <div class="home-expertise__bloc">
      <div class="home-expertise__bloc--left">
        <app-horizontal-step-card
          [svgIcon]="expertise_1.icon"
          [title]="expertise_1.title"
          [description]="expertise_1.description"
          [textLink]="expertise_1.text_link"
          [urlLink]="expertise_1.url">
        </app-horizontal-step-card>
        <app-horizontal-step-card
          [svgIcon]="expertise_2.icon"
          [title]="expertise_2.title"
          [description]="expertise_2.description"
          [textLink]="expertise_2.text_link"
          [urlLink]="expertise_2.url">
        </app-horizontal-step-card>
        <app-horizontal-step-card
          [svgIcon]="expertise_3.icon"
          [title]="expertise_3.title"
          [description]="expertise_3.description"
          [textLink]="expertise_3.text_link"
          [urlLink]="expertise_3.url">
        </app-horizontal-step-card>
      </div>
      <div class="home-expertise__bloc--right">
        <img
          class="home-expertise__image"
          width="340"
          height="340"
          [src]="image"
          alt="woman"
          loading="lazy"
          appImgFallback="/assets/images/Fall-back.png" />
      </div>
    </div>
  </div>
</div>
